/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Widerrufsrecht_DisclosureInputs */

const en_widerrufsrecht_disclosure = /** @type {(inputs: Widerrufsrecht_DisclosureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits are credited immediately. As digital content under BGB S356(5), they are exempt from the right of withdrawal.`)
};

const de_widerrufsrecht_disclosure = /** @type {(inputs: Widerrufsrecht_DisclosureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits werden sofort gutgeschrieben. Als digitale Inhalte gemaess BGB S356 Abs. 5 sind sie vom Widerrufsrecht ausgenommen.`)
};

const fr_widerrufsrecht_disclosure = /** @type {(inputs: Widerrufsrecht_DisclosureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les credits sont credites immediatement. En tant que contenu numerique selon le BGB S356(5), ils sont exemptes du droit de retractation apres livraison.`)
};

const es_widerrufsrecht_disclosure = /** @type {(inputs: Widerrufsrecht_DisclosureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los creditos se acreditan inmediatamente. Como contenido digital segun BGB S356(5), estan exentos del derecho de desistimiento tras la entrega.`)
};

const it_widerrufsrecht_disclosure = /** @type {(inputs: Widerrufsrecht_DisclosureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I crediti vengono accreditati immediatamente. Come contenuto digitale ai sensi del BGB S356(5), sono esenti dal diritto di recesso dopo la consegna.`)
};

const nl_widerrufsrecht_disclosure = /** @type {(inputs: Widerrufsrecht_DisclosureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits worden onmiddellijk bijgeschreven. Als digitale inhoud volgens BGB S356(5) zijn ze vrijgesteld van het herroepingsrecht na levering.`)
};

const pl_widerrufsrecht_disclosure = /** @type {(inputs: Widerrufsrecht_DisclosureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredyty sa naliczane natychmiast. Jako tresc cyfrowa zgodnie z BGB S356(5) sa one zwolnione z prawa do odstapienia po dostarczeniu.`)
};

const fi_widerrufsrecht_disclosure = /** @type {(inputs: Widerrufsrecht_DisclosureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krediitit hyvitetään välittömästi. Digitaalisena sisältönä BGB S356(5):n mukaisesti ne ovat vapautettu peruutusoikeudesta toimituksen jälkeen.`)
};

const da_widerrufsrecht_disclosure = /** @type {(inputs: Widerrufsrecht_DisclosureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits tilskrives straks. Som digitalt indhold iht. BGB S356(5) er de undtaget fra fortrydelsesretten efter levering.`)
};

const sv_widerrufsrecht_disclosure = /** @type {(inputs: Widerrufsrecht_DisclosureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krediter krediteras omedelbart. Som digitalt innehall enligt BGB S356(5) ar de undantagna fran angerratten efter leverans.`)
};

/**
* | output |
* | --- |
* | "Credits are credited immediately. As digital content under BGB S356(5), they are exempt from the right of withdrawal." |
*
* @param {Widerrufsrecht_DisclosureInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const widerrufsrecht_disclosure = /** @type {((inputs?: Widerrufsrecht_DisclosureInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Widerrufsrecht_DisclosureInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_widerrufsrecht_disclosure(inputs)
	if (locale === "fr") return fr_widerrufsrecht_disclosure(inputs)
	if (locale === "es") return es_widerrufsrecht_disclosure(inputs)
	if (locale === "it") return it_widerrufsrecht_disclosure(inputs)
	if (locale === "nl") return nl_widerrufsrecht_disclosure(inputs)
	if (locale === "pl") return pl_widerrufsrecht_disclosure(inputs)
	if (locale === "fi") return fi_widerrufsrecht_disclosure(inputs)
	if (locale === "da") return da_widerrufsrecht_disclosure(inputs)
	if (locale === "sv") return sv_widerrufsrecht_disclosure(inputs)
	return en_widerrufsrecht_disclosure(inputs)
});